// Calendar link helpers. Booking times are stored as naive IST wall-clock ISO strings.

const pad = (n) => String(n).padStart(2, "0");

const toUTCStamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

export function bookingEventTimes(booking) {
  const raw = booking.scheduled_at || "";
  // Interpret naive timestamps as IST
  const start = new Date(raw.includes("+") || raw.endsWith("Z") ? raw : `${raw}+05:30`);
  const end = new Date(start.getTime() + (booking.duration || 60) * 60000);
  return { start, end };
}

const eventTitle = (booking, withName) =>
  `CouncilOne: ${booking.service_name || "Advisory Session"}${withName ? ` with ${withName}` : ""}`;

const eventDetails = (booking) =>
  `${booking.service_name || "Advisory session"} on CouncilOne.${booking.google_meet_link ? `\nJoin: ${booking.google_meet_link}` : ""}`;

export function googleCalendarUrl(booking, withName = "") {
  const { start, end } = bookingEventTimes(booking);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: eventTitle(booking, withName),
    dates: `${toUTCStamp(start)}/${toUTCStamp(end)}`,
    details: eventDetails(booking),
    location: booking.google_meet_link || "Online",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadICS(booking, withName = "") {
  const { start, end } = bookingEventTimes(booking);
  const escape = (s) => String(s).replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//CouncilOne//Booking//EN",
    "BEGIN:VEVENT",
    `UID:${booking.booking_id}@councilone`,
    `DTSTAMP:${toUTCStamp(new Date())}`,
    `DTSTART:${toUTCStamp(start)}`,
    `DTEND:${toUTCStamp(end)}`,
    `SUMMARY:${escape(eventTitle(booking, withName))}`,
    `DESCRIPTION:${escape(eventDetails(booking))}`,
    `LOCATION:${escape(booking.google_meet_link || "Online")}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `councilone-session-${booking.booking_id}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
